import React, { useEffect } from 'react';

const useOutsideAlerter = (
    ref: React.RefObject<HTMLFormElement | HTMLDivElement>,
    fn: () => void
) => {
    useEffect(() => {
        function handleClickOutside(e: Event) {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                fn();
            }
        }
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [ref, fn]);
};

export { useOutsideAlerter };
